.modal-content {
  display: flex;
  position: relative;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  max-width: 64rem;
  max-height: min(80vh, 500px);
  overflow: auto;
}
